import React from "react";
import { MessageCircle } from "lucide-react";
import { BRAND } from "../../constants/brand";

export default function WhatsAppFloat() {
  return (
    <a
      href={BRAND.social.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-sm font-bold text-white shadow-lg transition-transform hover:-translate-y-0.5"
    >
      <MessageCircle size={18} /> WhatsApp
    </a>
  );
}
